<template>
  <DpplSkeletonLoader class="vertical-bar-chart-skeleton">
    <div class="skeleton-body">
      <div
        v-for="(bars, i) in barHeights"
        :key="i"
        class="bars"
      >
        <div class="chart-bars">
          <div
            v-for="(barHeight, j) in bars"
            :key="j"
            :style="{ height: `${barHeight}px` }"
            class="single-bar"
            :class="barColors[j]"
          />
        </div>

        <v-skeleton-loader
          type="text"
          width="48px"
          height="17px"
        />
      </div>
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';

export default {
  name: 'VerticalBarChartWidgetSkeleton',
  components: {
    DpplSkeletonLoader,
  },
  props: {
    numberOfBars: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      twoBars: [
        [170, 58],
        [170, 70],
        [123, 81],
        [52, 15],
        [170, 57],
        [123, 148],
      ],
      threeBars: [
        [170, 70, 15],
        [104, 70, 36],
        [130, 114, 9],
        [151, 161, 20],
        [130, 189, 15],
        [43, 70, 94],
        [20, 15, 15],
        [136, 136, 15],
        [121, 151, 82],
        [105, 70, 36],
        [222, 27, 0],
        [43, 27, 161],
      ],
      twoBarsColors: ['bar-color0', 'bar-color2'],
      threeBarsColors: ['bar-color0', 'bar-color1', 'bar-color2'],
    };
  },
  computed: {
    barHeights() {
      return this.numberOfBars === 2 ? this.twoBars : this.threeBars;
    },
    barColors() {
      return this.numberOfBars === 2 ? this.twoBarsColors : this.threeBarsColors;
    },
  },
};
</script>

<style scoped lang="less">
.vertical-bar-chart-skeleton {
  height: 100%;
  width: 100%;
}

.skeleton-body {
  height: calc(100% - 17px);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.bars {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-bars {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  margin-bottom: 16px;
}

.single-bar {
  width: 16px;

  &:not(:first-child) {
    margin-left: 4px;
  }
}

.bar-color0 {
  background-color: fade(@grey-400, 90%);
}

.bar-color1 {
  background-color: fade(@grey-400, 70%);
}

.bar-color2 {
  background-color: fade(@grey-400, 40%);
}
</style>
